<template>
    <div><div class="row">
        <div class="col-lg-12">
            <div v-if="saveError !== null" class="alert alert-danger" role="alert">
                <div v-for="error in saveError">
                    {{error}}
                </div>
            </div>
            <div v-if="saveSuccess" class="alert alert-success" role="alert">
                Mentés sikeres!
            </div>
        </div>
    </div>
        <div class="row">
            <div class="col-lg-12">
                <table class="table table-striped table-sm table-hover">
                    <thead class="bg-primary text-white">
                    <tr>
                        <th scope="col">
                            ID
                        </th>
                        <th scope="col">
                            Felhasználónév
                        </th>
                        <th scope="col">
                            E-mail cím
                        </th>
                        <th scope="col">
                            Szerepkör
                        </th>
                        <th scope="col">
                            Utolsó bejelentkezés
                        </th>
                        <th scope="col"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="user in users">
                        <th scope="row">{{user.id}}</th>
                        <td>{{user.username}}</td>
                        <td>{{user.email}}</td>
                        <td>{{user.role}}</td>
                        <td>{{user.lastLogin}}</td>
                        <td>
                            <button type="submit" class="btn btn-sm btn-primary" @click="editUser(user)">
                                <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                            </button>
                            <button type="submit" class="btn btn-sm btn-primary" @click="deleteUser(user.id)">
                                <i class="fa fa-trash" aria-hidden="true"></i>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="card mb-2">
            <div class="card-header">
                <div class="collapsed card-link" data-parent="#accordion">
                    {{ inputHeader }}
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-6 col-xl-3">
                        <div class="form-group">
                            <label for="username" class="sr-only">Felhasználónév</label>
                            <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                                <input
                                    id="username"
                                    type="text"
                                    class="form-control form-control-sm"
                                    v-model="inputUser.username"
                                    placeholder="Felhasználónév*"
                                    :disabled="isLoading"
                                    required
                                >
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-xl-3">
                        <div class="form-group">
                            <label for="password" class="sr-only">Jelszó</label>
                            <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                                <input
                                    id="password"
                                    type="text"
                                    class="form-control form-control-sm"
                                    v-model="inputUser.password"
                                    placeholder="Jelszó*"
                                    :disabled="isLoading"
                                    required
                                >
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-xl-3">
                        <div class="form-group">
                            <label for="email" class="sr-only">E-mail cím</label>
                            <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                                <input
                                    id="email"
                                    type="text"
                                    class="form-control form-control-sm"
                                    v-model="inputUser.email"
                                    placeholder="E-mail cím*"
                                    :disabled="isLoading"
                                    required
                                >
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-xl-3">
                        <div class="form-group">
                            <v-select
                                id="recorder"
                                :options="roles"
                                v-model="inputUser.role"
                                single
                                placeholder="Szerepkör*"
                            >
                                <div slot="no-options">Nincs a keresésnek megfelelő találat.</div>
                            </v-select>
                        </div>
                    </div>
                    <div class="col-lg-3 col-xl-2">
                        <button type="submit" class="btn btn-primary btn-block" @click.prevent="saveUser"
                                :disabled="isLoading">
                            <i class="fa fa-save"></i>
                            Mentés
                        </button>
                    </div>
                    <div class="col-lg-3 col-xl-2">
                        <button v-if="mode === 'edit'" type="submit" class="btn btn-primary btn-block" @click.prevent="resetInputUser"
                                :disabled="isLoading">
                            Mégsem
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import md5 from 'md5';
    const NewUserHeader = 'Új felhasználó';
    const EditUserHeader = 'Felhasználó adatainak módosítása';

    export default{
        name: "UserControl",
        data(){
            return {
                users: [],
                roles: [],
                mode: 'new',
                inputHeader: NewUserHeader,
                inputUser: {},
                saveSuccess: false
            }
        },
        computed: {
            saveError(){
                return this.$store.state.UserModul.saveError;
            },
            isLoading(){
                return this.$store.state.UserModul.saveLoading;
            }
        },
        watch: {
            mode(){
                if(this.mode === 'new'){
                   this.inputHeader = NewUserHeader;
                   this.resetInputUser();
                } else if(this.mode === 'edit'){
                    this.inputHeader = EditUserHeader;
                }
            },
            'inputUser.id'(){
                if(this.inputUser.id !== null){
                    this.mode = 'edit';
                } else {
                    this.mode = 'new';
                }
            }
        },
        methods: {
            resetInputUser(){
                this.inputUser = {
                    id: null,
                    username: '',
                    email: '',
                    password: ''
                };
            },
            loadRoles(){
                this.$store.dispatch('UserModul/getRoleList', {
                    result: (res)=> {
                        this.roles = [];
                        res.data.roleList.forEach(role => {
                            this.roles.push({
                                label: role.name,
                                value: role.id
                            });
                        });
                        this.loadUsers();
                    }
                });
            },
            loadUsers(){
                this.$store.dispatch('UserModul/getUserDataList', {
                    result: (res)=> {
                        this.users = [];
                        res.data.userList.forEach(user => {
                            this.users.push({
                                id: user.id,
                                username: user.username,
                                email: user.email,
                                role: user.role,
                                roleId: user.role_id,
                                lastLogin: user.last_login,
                            });
                        });
                    }
                });
            },
            saveUser(){
                this.saveSuccess = false;
                let payload = {
                    data: Object.assign({}, this.inputUser),
                    result: (res) => {
                        this.loadUsers();
                        this.resetInputUser();
                        this.saveSuccess = true;
                    },
                    reject: (rej) => {

                    }
                };
                payload.data.role = payload.data.role.value;
                if(this.mode === 'new'){
                    if(payload.data.password !== ''){
                        payload.data.password = md5(payload.data.password);
                    }
                    this.$store.dispatch('UserModul/saveUser', payload);
                } else {
                    if(payload.data.password !== '*****' && payload.data.password !== ''){
                        payload.data.password = md5(payload.data.password);
                    }
                    this.$store.dispatch('UserModul/editUser', payload);
                }
            },
            userRoleFormatter(roleId){
                return this.roles.find(role => {
                    return role.value === roleId;
                });
            },
            editUser(user){
                this.inputUser.id = user.id;
                this.inputUser.username = user.username;
                this.inputUser.email = user.email;
                this.inputUser.password = '*****';
                this.inputUser.role = this.roles.find(role => {
                    return role.value === user.roleId;
                });
            },
            deleteUser(userId){
                this.saveSuccess = false;
                this.$store.dispatch('UserModul/deleteUser', {
                    id: userId,
                    result: (res) => {
                        this.loadUsers();
                        this.resetInputUser();
                        this.saveSuccess = true;
                    },
                    reject: (rej) => {

                    }
                });
            }
        },
        mounted(){
            this.resetInputUser();
            this.loadRoles();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/admin/UserController.vue